import { render } from "./TutarialCategoryPanel.vue?vue&type=template&id=95d2c834&scoped=true"
import script from "./TutarialCategoryPanel.vue?vue&type=script&lang=js"
export * from "./TutarialCategoryPanel.vue?vue&type=script&lang=js"

import "./TutarialCategoryPanel.vue?vue&type=style&index=0&id=95d2c834&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-95d2c834"]])

export default __exports__